import React from 'react';

import testIds from '@smart-tv/e2e/shared/variables';

import Typography, { Props as TypographyProps } from '@smart-tv/components/typography/typography';

import formatDate from '@smart-tv/utils/date/format-date';

import styles from './content-item.module.scss';

interface Props extends Omit<TypographyProps, 'children'> {
  startTime: Date;
}

export const ContentItemStartTime: React.FC<Props> = (props: Props) => {
  const { startTime, ...rest } = props;

  return (
    <div className={styles['start-time']}>
      <Typography
        variant="caption"
        component="span"
        data-testid={testIds.contentItem.startTime}
        {...rest}
        className={styles['start-time-text']}
      >
        {formatDate(startTime, 'hh:mm')}
      </Typography>
    </div>
  );
};

export default React.memo(ContentItemStartTime);
